import styled from "styled-components";
import {Button} from "./shared/Button";
import {useWeb3Context} from "../web3-context/Web3Context";
import {useEffect, useState} from "react";
import {isLocalDev} from "../settings";

export function ConnectButton() {
  const [ensName, setEnsName] = useState<string | null>(null)
  const { provider, activeAddress, chainId, connect, disconnect } = useWeb3Context()

  useEffect(() => {
    if (isLocalDev || !activeAddress) return;
    (async () => {
      const name = await provider.lookupAddress(activeAddress)
      setEnsName(name)
    })()
  }, [activeAddress])

  const connected = !!activeAddress
  function onClick() {
    connected ? disconnect() : connect()
  }

  const shortenedAddress = connected ? `0×${activeAddress.slice(2, 6)}…${activeAddress.slice(-4)}` : ''
  const buttonText = connected ? ensName ?? shortenedAddress : "0×Connect"

  return <_ConnectButton>
    <Button onClick={onClick}>
      <div><ConnectCircle connected={connected} />{buttonText}</div>
    </Button>
  </_ConnectButton>
}

const _ConnectButton = styled.div`
  margin-left: auto;
`

const ConnectCircle = styled.div<{ connected: boolean }>`
  --dot: ${({ connected }) => {
     return connected ? 'var(--felixGreen)' : 'var(--wrigglerRed)' 
  }};

  display: inline-block;
  border-radius: 20px;
  background-color: var(--dot);
  width: 12px;
  height: 12px;
  margin-right: 10px;
 
`